import { createNotification } from '@/components';
import Link from '@/components/Link/Link';
import IntlMessages from '@/components/utility/intlMessages';
import { sendResetPasswordCode } from '@/services/auth/api';
import { Button, Form, Input, Space } from 'antd';
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router';

export function ForgotPasswordForm() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submittable, setSubmittable] = useState(false);

  const values = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);

  async function onSubmit(values) {
    setIsSubmitting(true);

    await sendResetPasswordCode(values.email)
      .then(({ message }) => {
        createNotification("success", message);
        navigate("/login")
      })
      .catch((e) => {
        if (e.response) {
          createNotification("error", e.response.data.message);
        } else {
          createNotification("error", "Network error");
        }
      }).finally(() => setIsSubmitting(false));
  }

  return (
    <Form
      layout={"vertical"}
      form={form}
      onFinish={(values) => {
        onSubmit(values);
      }}
    >
      <Form.Item
        name="email"
        label="E-mail"
        rules={[
          {
            required: true,
            message: 'Email is required',
          },
          {
            type: "email",
            message: "The input is not valid E-mail!",
          },
        ]}
      >
        <Input
          size="large"
          placeholder="saffe@saffe.ai"
        />
      </Form.Item>
      <Space align="start" className="flex justify-between">
        <div className="flex flex-col">
          <IntlMessages id="page.signInCreateAccount" />
          <Link
            to="/register"
            className="!text-primary hover:text-primary cursor-pointer"
          >
            <IntlMessages id="page.signInCreateAccountLink" />
          </Link>
        </div>
        <Form.Item>
          <div className="flex flex-col">
            <Button
              className="bg-primary border-0 text-white lg:!px-8 shadow-none flex"
              type="primary"
              shape="round"
              size="large"
              loading={isSubmitting}
              disabled={!submittable}
              htmlType="submit"
            >
              <IntlMessages id="page.forgotPasswordCTA" />
            </Button>
          </div>
        </Form.Item>
      </Space>
    </Form>
  )
}
